import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { sendJson } from '@hcr/api/shared'

import type { ProblemDetailsDto, UserUpdatePayloadDto } from '../../dtos'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

export const createUserUpdateMutation =
  (baseUrl: string) =>
  (
    { idToken }: AuthorizedRequestParams,
    options?: Partial<UseMutationOptions<void, ProblemDetailsDto, UserUpdatePayloadDto>>
  ) =>
    useMutation<void, ProblemDetailsDto, UserUpdatePayloadDto>({
      ...options,
      mutationFn: body =>
        sendJson({
          body,
          headers: createAuthorizationHeader(idToken),
          method: 'POST',
          url: `${baseUrl}/user/contact-details`,
        }),
    })
